import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { from, map, Observable } from 'rxjs';

export class WebpackTranslateLoader implements TranslocoLoader {
  getTranslation(lang: string): Observable<Translation> {
    return from(import(`../../../assets/i18n/${lang}.json`)).pipe(map((module: unknown) => getDefaultExport(module)));
  }
}

function getDefaultExport(module: unknown): Translation {
  if (typeof module === 'object' && module !== null && 'default' in module) {
    const translation: unknown = module.default;
    return isTranslation(translation) ? translation : {};
  }

  return {};
}

function isTranslation(value: unknown): value is Translation {
  return typeof value === 'object' && value !== null;
}
